import React from "react";
import { Popover, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { Share } from "../Icons/Icons";
import "./ShareLink.scss";

const ShareLink = ({ shareUrl }) => {
  const handleCopy = async (e) => {
    e.stopPropagation();

    try {
      await navigator.clipboard.writeText(shareUrl);
      message.success("Link copied successfully");
    } catch (err) {
      message.error("Failed to copy link");
    }
  };

  const content = (
    <div className="share-popup">
      <div className="share-title">Share your app url independently</div>

      <div className="share-subtitle">
        (See Help video for more information)
      </div>

      <div className="share-link-container">
        <span className="share-link">{shareUrl}</span>

        <CopyOutlined className="copy-icon" onClick={handleCopy} />
      </div>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      placement="bottomRight"
      overlayClassName="share-popover"
    >
      <div className="share-trigger">
        <Share />
      </div>
    </Popover>
  );
};

export default ShareLink;
